import React, { useEffect, useState } from "react";
import { backendURL } from "../../config/constants";

// Shown if the live list cannot be loaded. Mirrors the backend codes.
const FALLBACK_LANGUAGES = [
  { code: "eng", name: "English" },
  { code: "it", name: "Italian" },
  { code: "fr", name: "French" },
  { code: "es", name: "Spanish" },
  { code: "de", name: "German" },
  { code: "pt", name: "Portuguese" },
  { code: "ar", name: "Arabic" },
  { code: "zh-CN", name: "Chinese (Simplified)" },
  { code: "pl", name: "Polish" },
];

// Table of the exact values accepted for the "lang" field.
const SupportedLanguagesTable = () => {
  const [languages, setLanguages] = useState(FALLBACK_LANGUAGES);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(`${backendURL}/agents/supported-languages/`);
        if (!res.ok) throw new Error(`HTTP Error: ${res.status}`);
        const data = await res.json();
        if (!cancelled && Array.isArray(data.details) && data.details.length) {
          setLanguages(data.details);
        }
      } catch (err) {
        console.error("Error fetching languages:", err);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="docs-table">
      <h4 className="docs-response-title">
        Supported <code>lang</code> values
      </h4>
      <table>
        <thead>
          <tr>
            <th>Language</th>
            <th>Value to send</th>
          </tr>
        </thead>
        <tbody>
          {languages.map((lang) => (
            <tr key={lang.code}>
              <td>{lang.name}</td>
              <td>
                <code>{lang.code}</code>
                {lang.code === "eng" && " (default)"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupportedLanguagesTable;
